import(/* webpackMode: "eager" */ "/my-new-test/app/globals.css");
import(/* webpackMode: "eager" */ "/my-new-test/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/my-new-test/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/my-new-test/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/my-new-test/components/ui/tooltip.tsx")